import { useLingui } from '@lingui/react/macro'

export function useIndicators() {
  const { t } = useLingui()

  return {
    indicators: {
      competences: {
        competences: [
          {
            name: t`Productivity`,
            description: t`Workload orientation. Effort and interest in performance. Focus on the intensity and dimension of what has been achieved.`,
          },
          {
            name: t`Quality`,
            description: t`Attitude for detail and perfectionism. Orientation towards improvement and a job well done. Interest and determination by excellence in performance.`,
          },
          {
            name: t`Knowledge`,
            description: t`Ability and technical consistency. Aptitude for expert performance. Interest in working in a directed and methodical way.`,
          },
          {
            name: t`Planning`,
            description: t`Interest in defining objectives and setting goals. Sense of anticipation. Ability to visualize and dimension future scenarios.`,
          },
          {
            name: t`Organization`,
            description: t`Focus on the structure and order. Preference for the rational and the systematic. Ability to establish criteria, sequences and priorities.`,
          },
          {
            name: t`Supervision`,
            description: t`Guidance to follow up on objectives, goals and procedures. Focus on the analysis of deviations. Ability to control.`,
          },
          {
            name: t`Leadership`,
            description: t`Influence on people. Interest for cohesion and for generating trust. Ability to lead and to accompany in the achievement of goals and achievements.`,
          },
          {
            name: t`Communication`,
            description: t`Ability to express and to listen. Interest in making oneself understood and in understanding others. Openness to dialogue.`,
          },
          {
            name: t`Negotiation`,
            description: t`Interest in interdependence, agreement and pact. Motivation by reciprocity. Ability to plan and achieve consensus.`,
          },
          {
            name: t`Training`,
            description: t`Interest for knowledge. Orientation to the development of skills and aptitudes. Willingness to be involved in processes that facilitate learning.`,
          },
          {
            name: t`Motivation`,
            description: t`Ability to recognize and satisfy one's own needs and those of others. Positive attitude. Willingness to provide encouragement in the face of difficulties.`,
          },
          {
            name: t`Delegation`,
            description: t`Interest in sharing work and resources without disregarding responsibilities. Ability to adopt decentralized and distributed behaviors.`,
          },
          {
            name: t`Decision making`,
            description: t`Ability and firmness to meet the needs. Intensity and rapidity of response. Determination, audacity and decisive efficiency.`,
          },
          {
            name: t`Initiative`,
            description: t`Ability to provide new proposals. Variety of alternatives in performance. Interest in renewing approaches and points of view.`,
          },
          {
            name: t`Innovation`,
            description: t`Interest in inventiveness Ability to pose performance creatively and away from the conventional. Originality in the contributions.`,
          },
          {
            name: t`Commitment`,
            description: t`Attitude of commitment and emotional and personal involvement. Sense of belonging, loyalty and high identification with the position, performance and project.`,
          },
          {
            name: t`Collaboration`,
            description: t`Interest in sharing. Ability to participate and contribute. Orientation towards co-responsibility. Disposition towards the collective.`,
          },
          {
            name: t`Adaptation`,
            description: t`Versatility. Openness to flexibility. Low resistance to change. Ability to respond in new and undefined situations.`,
          },
        ],
        vectors: [
          {
            name: t`Technical training`,
            description: t`Ability to implement and integrate Productivity, Quality and Expertise into performance.`,
          },
          {
            name: t`Management Dynamics`,
            description: t`Ability to exercise and manage the Planning, Organization and Oversight required by performance.`,
          },
          {
            name: t`Integrative relationship`,
            description: t`Talent to establish and develop Leadership, Communication and Negotiation in interpersonal relationships.`,
          },
          {
            name: t`Development stimulus`,
            description: t`Ability to use Training, Motivation and Delegation in the field of personal growth.`,
          },
          {
            name: t`Anticipation for Improvement`,
            description: t`Capacity to exercise Decision-Making, Initiative and Innovation as relevant Competencies in performance.`,
          },
          {
            name: t`Positive Behavior`,
            description: t`Talent and willingness to use Commitment, Collaboration and Adaptation in the professional activity.`,
          },
        ],
        dimensions: [
          { name: t`Task`, description: t`Addressed towards Technical Training and Management Dynamics.` },
          {
            name: t`People`,
            description: t`Addressed towards the Integrative Relationship and towards the Development Stimulus.`,
          },
          {
            name: t`Context`,
            description: t`Addressed towards the Anticipation for Improvement and Positive Behavior.`,
          },
        ],
        titles: {
          competences: t`Competencies`,
          vectors: t`Vectors`,
          dimensions: t`Dimensions`,
          match: {
            high: t`High coincidence`,
            medium: t`Intermediate coincidence`,
            low: t`Low coincidence`,
          },
          behaviors: {
            high: t`Relevants`,
            medium: t`Intermediate`,
            low: t`Non-relevant`,
          },
        },
      },
      values: {
        competences: [
          {
            name: t`Simplicity`,
            description: t`Clear description and implementation of systems and methods. Prioritizing simplicity in the design and implementation of processes and procedures.`,
          },
          {
            name: t`Agility`,
            description: t`Ease and functionality in the methods. Speed and flexibility in processes. Adaptability and reversibility in procedures.`,
          },
          {
            name: t`Efficiency`,
            description: t`Optimization of systems, processes and procedures. Maximization in the achievement of objectives while minimizing resources.`,
          },
          {
            name: t`Transversality`,
            description: t`Implementation of interdependence and coordination in processes and projects. Priority of interdepartmental vision. Shared design of procedures.`,
          },
          {
            name: t`Innovation`,
            description: t`Recognition of inventiveness. Bet on creativity. Promotion of the new and the alternative. Originality and avant-garde in processes, technologies, methods and resources.`,
          },
          {
            name: t`Excellence`,
            description: t`Strive for the best. Exceptional interest in achieving the highest quality. Eagerness to exceed standards and improve processes and procedures.`,
          },
          {
            name: t`Remuneration`,
            description: t`Interest in establishing fair and competitive rewards. Implementation of diversified, customizable and incentive remuneration plans.`,
          },
          {
            name: t`Wellbeing`,
            description: t`Implementation of principles and actions to establish a healthy lifestyle. Interest in satisfying the health, psychological and social needs of people.`,
          },
          {
            name: t`Development`,
            description: t`Establishment of learning and personal and professional growth plans. Facilitation of actions for self-realization and professional career progress.`,
          },
          {
            name: t`Empowerment`,
            description: t`Decisive commitment to autonomy, participation and the protagonism of people. Encouraging responsibility, the ability to decide and access to resources.`,
          },
          {
            name: t`Conciliation`,
            description: t`Facilitation of compatibility between work life and personal, family and social life. Multiplicity and flexibility in the forms, times and places of professional performance.`,
          },
          {
            name: t`Diversity`,
            description: t`Openness and interest in selecting, integrating and promoting people, without bias or prejudice. Commits to establishing heterogeneous teams on a personal, cultural and social level.`,
          },
          {
            name: t`Sense`,
            description: t`Determination to build a principled organization. Definition and development of a project that provides value beyond strictly economic aspects.`,
          },
          {
            name: t`Transparency`,
            description: t`Design of actions so that the real information of the organization can be consulted in an open and accessible way. Veracity and relevance of what was shared.`,
          },
          {
            name: t`Integrity`,
            description: t`Development of an organizational culture based on ethics, honesty, openness and justice. Determination for honesty and coherence between principles and actions.`,
          },
          {
            name: t`Responsibility`,
            description: t`Active and voluntary contribution of the organization to social improvement and development. Community contribution beyond compliance with laws or required standards.`,
          },
          {
            name: t`Sustainability`,
            description: t`Determination to minimize the negative impact on the environment. Maximization of policies, plans and actions to care for the environment and the planet.`,
          },
          {
            name: t`Reputation`,
            description: t`Interest in maximizing the opinion and concept that interest groups have of the organization. Index of recognition and social valuation of the company.`,
          },
        ],
        vectors: [
          { name: t`Procedural Flexibility`, description: t`Integration of Simplicity, Agility and Efficiency.` },
          {
            name: t`Methodological Uniqueness`,
            description: t`Implementation of Transversality, Innovation and Excellence.`,
          },
          { name: t`Motivational Incentive`, description: t`Interest in Remuneration, Wellbeing and Development.` },
          { name: t`Integrative Commitment`, description: t`Bet on Empowerment, Conciliation and Diversity.` },
          { name: t`Organizational Purpose`, description: t`Orientation towards Meaning, Transparency and Integrity.` },
          {
            name: t`Socio-environmental Implication`,
            description: t`Determination by Responsibility, Sustainability and Reputation.`,
          },
        ],
        dimensions: [
          {
            name: t`Processes`,
            description: t`Prioritization of Procedural Flexibility and Methodological Singularity.`,
          },
          { name: t`People`, description: t`Direction towards Motivational Incentive and Integrative Commitment.` },
          { name: t`Around`, description: t`Focus on Organizational Purpose and Socio-Environmental Implication.` },
        ],
        titles: {
          competences: t`Values`,
          vectors: t`Principles`,
          dimensions: t`Scopes`,
          match: {
            high: t`High coincidence`,
            medium: t`Intermediate match`,
            low: t`Low match`,
          },
          behaviors: {
            high: t`Relevant`,
            medium: t`Intermediates`,
            low: t`Not relevant`,
          },
        },
      },
      personality: {
        competences: [
          {
            name: t`Containment`,
            description: t`Limited expression of emotions and relational detachment. Guidance on compliance with standards. Precision, meticulousness, obedience and formality.`,
          },
          {
            name: t`Caution`,
            description: t`Self-control. Low orientation towards what is different, what is new and what is creative. Prudence in the face of risk and uncertainty. Distrust, tension and alertness to the unknown.`,
          },
          {
            name: t`Rationality`,
            description: t`Preponderance of the cognitive over the emotional. Impulse control. Prevalence of logic, analysis and procedures. Preference for data, facts and evidence.`,
          },
          {
            name: t`Opening`,
            description: t`Curiosity, exploration and entrepreneurship. Interest in new ideas, experiences and ways of thinking. Broad, heterogeneous and diverse intellectual background.`,
          },
          {
            name: t`Ingenuity`,
            description: t`Inventiveness, innovation and creativity. Ability to imagine the different and the alternative. Divergent thinking and originality in approaches.`,
          },
          {
            name: t`Influence`,
            description: t`Loquacity, effusiveness and enthusiasm. Communicative and argumentative ability to persuade and inspire. Intellectual ability, optimism and sociability.`,
          },
          {
            name: t`Sensitivity`,
            description: t`Intense and spontaneous expression of feelings. Delicacy, subtlety and susceptibility. Propensity to be moved by beauty and aesthetic values.`,
          },
          {
            name: t`Introspection`,
            description: t`Ability to observe and analyze one's own conscience. Understanding inner moods. Tendency toward deep emotional self-knowledge.`,
          },
          {
            name: t`Singularity`,
            description: t`Tendency to feel different and special. Intense search for differentiation. Need to show and achieve a unique and unusual individuality.`,
          },
          {
            name: t`Extraversion`,
            description: t`Intensity and determination socially and relationally. Happy, open, positive and uninhibited attitude. Need to be the center of attention collectively.`,
          },
          {
            name: t`Empathy`,
            description: t`Ability to identify, understand and share the thoughts and emotions of others. Ability to recognize, feel and satisfy the needs of others.`,
          },
          {
            name: t`Responsibility`,
            description: t`Organizational and planning skills. Efficiency, reliability, perseverance and delivery. Orientation to achieve and fulfill objectives.`,
          },
          {
            name: t`Affability`,
            description: t`Solicitous, adaptive and conciliatory attitude. Confident, friendly, accommodating, helpful and accommodating behavior.
Tendency to seek consensus and avoid confrontation.`,
          },
          {
            name: t`Confluence`,
            description: t`Tendency to agree with others. Under address to the discrepancy. Orientation to concurrence with the ideas, principles and positions of the majority.`,
          },
          {
            name: t`Stability`,
            description: t`Balance and emotional equanimity. Calmness, good sense and serenity in forms. Self-control and calm in the manifestation of feelings.`,
          },
          {
            name: t`Dominance`,
            description: t`Orientation to leadership and power. Intensity, self-confidence and independence. Need to be in control and attitude of dominance over others.`,
          },
          {
            name: t`Demand`,
            description: t`Need for control, perfectionism and thoroughness. Intense demand towards self and others. Rigor and duty-oriented.`,
          },
          {
            name: t`Impulsiveness`,
            description: t`Tendency to react suddenly, unexpectedly and excessively. Intense and automatic response from the instinctive and emotional. Limited expression of the reflective.`,
          },
        ],
        vectors: [
          {
            name: t`Contracted Cognitive`,
            description: t`Integration of Containment, Caution and Rationality.`,
          },
          {
            name: t`Expansive Cognitive`,
            description: t`Integration of Openness, Wit and Influence.`,
          },
          {
            name: t`Implosive Emotional`,
            description: t`Determination by Sensitivity, Introspection and Singularity.`,
          },
          {
            name: t`Relational Emotional`,
            description: t`Determination by Extraversion, Empathy and Responsibility.`,
          },
          {
            name: t`Moderate Active`,
            description: t`Orientation towards Affability, Confluence and Stability.`,
          },
          {
            name: t`Intense Active`,
            description: t`Orientation towards Dominance, Demandingness and Impulsivity.`,
          },
        ],
        dimensions: [
          {
            name: t`Thought`,
            description: t`Prioritization of the Contracted Cognitive and the Expansive Cognitive.`,
          },
          {
            name: t`Emotion`,
            description: t`Direction towards the Implosive Emotional and towards the Relational Emotional.`,
          },
          {
            name: t`Action`,
            description: t`Focus on the Moderate Active and the Intense Active.`,
          },
        ],
        titles: {
          competences: t`Traits`,
          vectors: t`Types`,
          dimensions: t`Centers`,
          match: {
            high: t`High coincidence`,
            medium: t`Intermediate match`,
            low: t`Low match`,
          },
          behaviors: {
            high: t`Relevant`,
            medium: t`Intermediates`,
            low: t`Not relevant`,
          },
        },
      },
    },
    indicatorsOrgs: {
      basic: [
        {
          name: t`Commitment to the organization`,
          description: t`Sharing the principles and values of the organization and acting consistently with oneself and with that organization.`,
        },
        {
          name: t`Information management`,
          description: t`Ability to collect, organize, and prioritize relevant information according to objectives, drawing appropriate conclusions.`,
        },
        {
          name: t`Productivity`,
          description: t`Ability to effectively manage time and resources, achieving goals and contributing value in the work environment.`,
        },
        {
          name: t`Quality`,
          description: t`Ability to perform tasks accurately, with attention to detail, and meeting established standards.`,
        },
        {
          name: t`Market access`,
          description: t`Knowledge and mastery of job search techniques, the sector, and positions of interest, and understanding of labor rights and duties.`,
        },
        {
          name: t`Self-planning`,
          description: t`Ability to structure and manage personal tasks, defining priorities and times to achieve one's own objectives effectively.`,
        },
        {
          name: t`Organization`,
          description: t`Ability to structure and manage tasks, resources, and time efficiently, ensuring the achievement of established work objectives.`,
        },
        {
          name: t`Supervision of simple tasks`,
          description: t`Ability to review and guide the execution of basic activities, ensuring they are correctly achieved according to established guidelines.`,
        },
        {
          name: t`Compliance with standards`,
          description: t`Ability to adhere to defined standards, procedures, and guidelines, ensuring order and consistency in executed tasks.`,
        },
        {
          name: t`Resolution of simple tasks`,
          description: t`Ability to initiate, execute, and complete basic activities efficiently and autonomously, following established procedures.`,
        },
        {
          name: t`Time management`,
          description: t`Ability to plan and use time effectively, ensuring tasks are completed within established deadlines.`,
        },
        {
          name: t`Learning ability`,
          description: t`Ability to quickly and effectively acquire new knowledge and skills, adapting to changes and challenges.`,
        },
        {
          name: t`Basic digital communication`,
          description: t`Ability to effectively use digital tools and platforms to interact with information clearly and appropriately.`,
        },
        {
          name: t`Literacy`,
          description: t`Ability to communicate in Catalan and Spanish. Speak, read, and write.`,
        },
        {
          name: t`Analysis of simple problems`,
          description: t`Ability to recognize and examine fundamental situations or problems, suggesting appropriate solutions logically and efficiently.`,
        },
        {
          name: t`Functional calculation`,
          description: t`Ability to perform basic operations for routine activities.`,
        },
        {
          name: t`Basic computing`,
          description: t`Knowledge and use of basic computer programs and resources.`,
        },
        {
          name: t`Professional ethics`,
          description: t`Ability to act with integrity, responsibility, and respect in the work environment, guiding behavior by principles and values.`,
        },
      ],
      professional: [
        {
          name: t`Conflict resolution`,
          description: t`Ability to identify, address, and manage conflicts and seek constructive solutions for all parties involved, maintaining a positive work environment.`,
        },
        {
          name: t`Results orientation`,
          description: t`Ability to direct work towards achieving objectives with the necessary quality and efficiency to reach the best result.`,
        },
        {
          name: t`Sustainability`,
          description: t`Ability to manage resources responsibly, considering environmental and social impacts, and ensuring actions that promote long-term well-being.`,
        },
        {
          name: t`Strategic vision`,
          description: t`Ability to visualize opportunities and risks, anticipating the future, and making medium/long-term decisions that align with the organization's objectives.`,
        },
        {
          name: t`Effective supervision`,
          description: t`Ability to guide, supervise, and support work teams, ensuring the achievement of objectives and skill development, maintaining a productive and trusting environment.`,
        },
        {
          name: t`Technical decision making`,
          description: t`Personal qualities that enable impartial examination of different alternatives, selecting the most feasible based on a technical and professional analysis of the potential impacts of the decision.`,
        },
        {
          name: t`Leadership`,
          description: t`Ability to influence people, build trust, and lead cohesive teams towards achieving goals and accomplishments.`,
        },
        {
          name: t`Negotiation`,
          description: t`Ability to seek agreements and consensus, promoting reciprocity and interdependence to achieve mutually beneficial agreements.`,
        },
        {
          name: t`Team training`,
          description: t`Ability to acquire, renew, and use the knowledge and skills required for effective performance and continuous team development in the work environment.`,
        },
        {
          name: t`Team motivation`,
          description: t`Ability to convey recognition and satisfaction, as well as to motivate and stimulate commitment, enthusiasm, and energy in the team, promoting active involvement and achieving common goals.`,
        },
        {
          name: t`Communication`,
          description: t`Ability to communicate concepts clearly and to listen actively, showing an interest in understanding others and maintaining an open and effective dialogue.`,
        },
        {
          name: t`Delegation`,
          description: t`Ability to coordinate tasks and resources efficiently, adopting decentralized and distributed approaches, maintaining responsibility, to optimize team performance.`,
        },
        {
          name: t`Resource management`,
          description: t`Ability to manage and use available resources effectively, maximizing their optimal use to meet work objectives.`,
        },
        {
          name: t`Rigor, method, and quality`,
          description: t`Ability to carry out tasks with care, thoroughness, and attention to detail, applying a systematic method with continuous control, monitoring, and verification of objective results.`,
        },
        {
          name: t`Advanced tool use`,
          description: t`Ability to expertly handle specialized tools to optimize the achievement of results in the work environment.`,
        },
        {
          name: t`Technical problem solving`,
          description: t`Ability to identify, analyze, and solve difficult technical issues, applying advanced knowledge and innovative solutions effectively and efficiently.`,
        },
        {
          name: t`Planning others' work`,
          description: t`Ability to determine goals, define priorities, and schedule activities required to achieve area or team objectives, considering available resources and time.`,
        },
        {
          name: t`Organizing others' work`,
          description: t`Ability to structure and coordinate tasks, allocate resources, and distribute responsibilities within the area or team, ensuring work is carried out effectively and on time.`,
        },
      ],
      transversal: [
        {
          name: t`Citizen orientation`,
          description: t`Ability to identify and meet the needs of citizens, facilitating their relationship with the environment and responding to their demands.`,
        },
        {
          name: t`Collaborative teamwork`,
          description: t`Ability to cooperate and be part of work groups to complete common objectives.`,
        },
        {
          name: t`Pressure tolerance`,
          description: t`Ability to maintain effectiveness in stressful or pressured situations with self-control of emotions and avoiding impulsive reactions, even in complex contexts.`,
        },
        {
          name: t`Autonomy and proactivity`,
          description: t`Ability to act proactively and autonomously, solving situations efficiently and pursuing goals beyond what is expected, without requiring supervision.`,
        },
        {
          name: t`Lifelong learning`,
          description: t`Ability to stay up-to-date in the work field, putting in personal time and effort, and contributing to the organization's knowledge management.`,
        },
        {
          name: t`Interpersonal understanding`,
          description: t`Ability to listen and understand the actions, ideas, approaches, thoughts, emotions, and feelings of individuals and groups, even if not verbally expressed, generating a positive climate that facilitates professional performance.`,
        },
        {
          name: t`Influence and persuasion`,
          description: t`Ability to cause a certain impact, persuade others, and gain opinions, decisions, and actions necessary to achieve assigned work objectives, respecting ethical principles and work values.`,
        },
        {
          name: t`Global vision`,
          description: t`Ability to understand the work environment and anticipate the effects of professional actions on the organization to identify the most appropriate proposals and responses.`,
        },
        {
          name: t`Ethics in decision making`,
          description: t`Ability to make decisions based on ethical values, ensuring actions are fair, responsible, and adhere to ethical principles and professional standards.`,
        },
        {
          name: t`Initiative`,
          description: t`Ability to lead in identifying opportunities and executing actions without needing to be directed, showing willingness and proactivity to solve problems and generate improvements.`,
        },
        {
          name: t`Innovation orientation`,
          description: t`Ability to promote an environment that encourages the generation and implementation of new ideas, creating value through new or improved services and processes.`,
        },
        {
          name: t`Commitment to public service`,
          description: t`Ability to adhere to the principles and values of public administration, behaving consistently with oneself and the entity.`,
        },
        {
          name: t`Adaptation`,
          description: t`Ability to flexibly adapt to changes in the environment or situations, maintaining efficiency in performance and learning from new situations.`,
        },
        {
          name: t`Critical and resolutive thinking`,
          description: t`Ability to think holistically and turn complex information into creative and innovative solutions.`,
        },
        {
          name: t`Assertive communication`,
          description: t`Ability to express thoughts and emotions clearly, respectfully, and appropriately, protecting personal rights without aggressing or submitting to others.`,
        },
        {
          name: t`Empathy`,
          description: t`Ability to understand and share the emotions, thoughts, and viewpoints of others, promoting a positive emotional bond.`,
        },
        {
          name: t`Creativity`,
          description: t`Ability to conceive novel and unique ideas, find creative solutions to problems, and adapt ingeniously to circumstances.`,
        },
        {
          name: t`Transversality`,
          description: t`Ability to use knowledge, approaches, and skills from different disciplines in various work contexts, fostering collaboration and teamwork to achieve common goals.`,
        },
      ],
      directives: [
        {
          name: t`Strategic Leadership`,
          description: t`Ability to define and establish a short- and long-term vision and align teams toward achieving strategic objectives to address emerging organizational challenges.`,
        },
        {
          name: t`Change Management`,
          description: t`Ability to lead organizational change, demonstrating commitment, adaptability, and flexibility in addressing it.`,
        },
        {
          name: t`Influential Communication`,
          description: t`Ability to convey all kinds of concepts in a clear, compelling, and strategic manner.`,
        },
        {
          name: t`Team and People Development`,
          description: t`Ability to train, incentivize, strengthen, and motivate human talent.`,
        },
        {
          name: t`Talent Management`,
          description: t`Identification, retention, promotion, and development of human capital within the organization.`,
        },
        {
          name: t`Results-Oriented`,
          description: t`Ability to orient work toward achieving objectives with the highest quality and effectiveness necessary to achieve the best results.`,
        },
        {
          name: t`Negotiation, Influence, and Persuasion`,
          description: t`Ability to reach agreements that create a specific impact and persuade others. Necessary competency to gain opinions, decisions, and actions, and to achieve assigned work objectives, while respecting ethical principles and work values.`,
        },
        {
          name: t`Team Conflict Management`,
          description: t`Ability to effectively detect, address, and resolve conflicts in work teams, fostering dialogue, negotiation, and mediation to achieve solutions that enhance cooperation and the work environment through a neutral stance.`,
        },
        {
          name: t`Decision-making`,
          description: t`Ability to make decisions based on information analysis and take calculated risks, ensuring that actions are fair, responsible, and adhere to ethical principles and professional standards.`,
        },
        {
          name: t`External and Internal Customer Focus`,
          description: t`Ability to understand, anticipate, and react effectively to the demands and expectations of external customers and internal collaborators, establishing bonds of trust and solutions that ensure optimal service.`,
        },
        {
          name: t`Innovation and Creativity Focus`,
          description: t`Ability to generate and promote an environment for implementing new ideas and divergent and optimal solutions, creating value through services, processes, and a culture of innovation.`,
        },
        {
          name: t`Ethics and Corporate Responsibility`,
          description: t`Ability to behave with integrity, transparency, and commitment to the organization's values, ensuring compliance with internal and external regulations.`,
        },
        {
          name: t`Adaptability and Resilience`,
          description: t`Ability to flexibly adapt to environmental variations, maintaining efficient performance, and learning from new situations.`,
        },
        {
          name: t`Critical and Analytical Thinking`,
          description: t`Ability to think holistically and, through data analysis, detect patterns and transform complex information into optimal, well-founded decisions and solutions.`,
        },
        {
          name: t`Planning and Organization`,
          description: t`Ability to identify and prioritize tasks and deadlines, delegate them, and manage the necessary resources.`,
        },
        {
          name: t`Emotional Intelligence`,
          description: t`Self-awareness and empathy. Ability to understand and share one's own and others' emotions, thoughts, and points of view, fostering a positive emotional bond.`,
        },
        {
          name: t`Networking and Collaboration`,
          description: t`Ability to network and strategically build alliances within and outside the institution.`,
        },
        {
          name: t`Business Vision`,
          description: t`Ability to understand the market and the organization to create value and competitive advantage.`,
        },
      ],
    },
  }
}
